import { useEffect } from 'react';
import type { UmmVersionsResponse } from 'src/apis/iip-service/types';
import type { UmmDetailsRequest } from 'src/apis/iip-service/use-umm';
import { useAxios } from 'src/hooks/use-axios';

export const useUmmVersions = ({
  ummRequest,
}: {
  ummRequest: UmmDetailsRequest;
}) => {
  const request = useAxios(
    (axios, baseConfig, url: string) =>
      axios.request<UmmVersionsResponse>({
        ...baseConfig,
        url,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    if (!ummRequest.response) return;

    if (ummRequest.response.data._links?.versions) {
      request.execute(ummRequest.response.data._links.versions.href);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ummRequest.response]);

  return request;
};

export type UmmVersionsRequest = ReturnType<typeof useUmmVersions>;
